import React from 'react';
import PropTypes from 'prop-types';
import BookingList from 'components/booking-list';
import moment from 'moment';

import './style.css';

const BookingsDetailList = ({ date, bookings, userKey }) => {
  const filtered = bookings.filter((doc) => {
    const { dateStart, dateEnd } = doc.data();
    const d1 = moment.utc(dateStart);
    const d2 = moment.utc(dateEnd);
    const diff = d2.diff(d1, 'days')+1;
    
    // eslint-disable-next-line no-plusplus
    for (let i=0; i<diff; i++) {
      const day = d1.clone().add(i, 'days');
      const match = day.isSame(date, 'day');
      
      if (match) return true;
    }
    return moment.utc(dateStart).isSame(date, 'day');
  });
  return <BookingList bookings={filtered} userKey={userKey} />;
};

BookingsDetailList.propTypes = {
  userKey: PropTypes.string.isRequired,
  date: PropTypes.shape({
    getDay: PropTypes.func,
  }),
  bookings: PropTypes.arrayOf(
    PropTypes.shape({
      startDate: PropTypes.string,
      rate: PropTypes.number,
    })
  ).isRequired,
};

BookingsDetailList.defaultProps = {
  date: Date.now(),
};

export default BookingsDetailList;
